import React from "react";
import PropTypes from "prop-types";
import { DatePicker } from "@mui/x-date-pickers";
import { useController, useFormContext } from "react-hook-form";
import { FormControl } from "@mui/material";
import dayjs from "dayjs";
import CalenderSchedule from '../../../components/Quoters/Aflac/icons/calender-schedule.svg?react';

export default function DateInput(props) {
  const {
    label,
    name,
    fullWidth,
    calenderOpen,
    onChange,
    setCalenderOpen,
    variant,
    inputVariant,
    InputProps,
    inputProps,
    InputLabelProps,
    FormHelperTextProps,
    ...datePickerProps
  } = props;

  const formContext = useFormContext();
  const { field, fieldState: { error } } = useController({
    name,
    control: formContext?.control,
    defaultValue: null
  });

  const handleChange = (newValue) => {
    if (!newValue) {
      field.onChange(null);
    } else {
      const now = dayjs();
      const dateWithTime = dayjs(newValue)
        .hour(now.hour())
        .minute(now.minute())
        .second(now.second());

      field.onChange(dateWithTime);
      onChange?.(dateWithTime);
    }
  };

  return (
    <FormControl fullWidth>
      <DatePicker
        format="MM/DD/YYYY"
        value={field.value ? dayjs(field.value) : null}
        onChange={handleChange}
        open={calenderOpen}
        onOpen={() => setCalenderOpen(true)}
        onClose={() => setCalenderOpen(false)}
        {...datePickerProps}
        slots={{ openPickerIcon: CalenderSchedule }}
        slotProps={{
          field: {
            input: InputProps,
            htmlInput: inputProps,
            onClick: () => setCalenderOpen(true),
            onKeyDown: (e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                setCalenderOpen(true);
              }
            },
          },

          textField: {
            variant: variant || "filled",
            error: !!error,
            helperText: error?.message,
            fullWidth: fullWidth !== undefined ? fullWidth : true,
            label: label,
            InputLabelProps,
            FormHelperTextProps,
          },
        }}
      />
    </FormControl>
  );
}

DateInput.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  variant: PropTypes.string,
  inputVariant: PropTypes.string,
  errors: PropTypes.object,
  calenderOpen: PropTypes.bool,
  setCalenderOpen: PropTypes.func,
};
